import React, { useState, useEffect } from 'react';
import { Image } from 'lucide-react';

export const ServiceGallery = ({ service }) => {
  const [photos, setPhotos] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchPhotos = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/photos/${service}`);
        const data = await response.json();
        if (data.success) {
          setPhotos(data.photos);
        }
      } catch (error) {
        // Silently fail - photos are optional
      } finally {
        setIsLoading(false);
      }
    };

    fetchPhotos();
  }, [service]);

  if (isLoading) {
    return null; // Don't show loading state for optional gallery
  }

  if (photos.length === 0) {
    return null; // Don't show empty gallery
  }

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold text-gray-900 mb-2">
            Our <span className="text-primary">Recent Work</span>
          </h2>
          <p className="text-gray-600">
            See examples of our completed projects
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {photos.map((photo) => (
            <div
              key={photo._id}
              className="group relative overflow-hidden rounded-xl shadow-lg aspect-[4/3]"
            >
              <img
                src={photo.url}
                alt={photo.label || 'Project photo'}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              {(photo.label || photo.suburb) && (
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
                    {photo.label && (
                      <p className="font-semibold text-lg">{photo.label}</p>
                    )}
                    {photo.suburb && (
                      <p className="text-sm text-gray-300">{photo.suburb}</p>
                    )}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
